package com.trevorwiebe.timesheet.core.domain.model

import com.trevorwiebe.timesheet.core.domain.Util.convertStringToLocalDateTime
import com.trevorwiebe.timesheet.core.domain.Util.toIsoStringWithMillis
import com.trevorwiebe.timesheet.core.domain.dto.OrganizationDto
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone

data class Organization(
    val id: String,
    val name: String,
    val goLiveDate: LocalDateTime,
    val billingAddress: String = "",
    val billingPhone: String = "",
    val billingEmail: String = "",
    val remitTo: String = "",
)

fun OrganizationDto.toOrganization(id: String): Organization {
    return Organization(
        id = id,
        name = name,
        goLiveDate = convertStringToLocalDateTime(goLiveDate),
        billingAddress = billingAddress,
        billingPhone = billingPhone,
        billingEmail = billingEmail,
        remitTo = remitTo,
    )
}

fun Organization.toOrganizationDto(): OrganizationDto {
    return OrganizationDto(
        name = name,
        goLiveDate = goLiveDate.toIsoStringWithMillis(TimeZone.currentSystemDefault()),
        billingAddress = billingAddress,
        billingPhone = billingPhone,
        billingEmail = billingEmail,
        remitTo = remitTo,
    )
}
